import React from "react";
import PlayBtn from "../common/playBtn/PlayBtn";
import "./card.scss";
const Card = ({
  varient,
  children,
  imgUrl,
  altText,
  title,
  avatar,
  time,
  href,
}) => {
  return (
    <div className={varient ? `card ${varient}` : "card"}>
      <div className="card_play">
        <img src={imgUrl} alt={altText} />
        <PlayBtn />
      </div>
      <h2 className="card_title">
        <a href={href}>{title}</a>
      </h2>
      <div className="card_meta_info">
        <div className="card_meta">
          <a href={href} className="card_avatar">
            {avatar}
          </a>
          <span className="card_time">{time}</span>
        </div>
      </div>
      {children}
    </div>
  );
};
Card.defaultProps = {
  href: "#",
};
export default Card;
